<form
  [formGroup]="editForm"
  (ngSubmit)="onSubmit()"
  enctype="multipart/form-data"
>
  <div class="form-group form-floating mb-3">
    <div class="form-floating mb-4" [appValidateState]="editForm.get('title')">
      <input
        id="name"
        formControlName="name"
        type="text"
        class="form-control"
        placeholder="Title"
        i18n-placeholder="@@title"
        autocomplete="off"
      />
      <label for="name" i18n="@@title">{{ "title" | transloco }}</label>
    </div>
  </div>
  <div class="form-group form-floating mb-2">
    <app-datalist-select
      class=""
      [options]="ParentFolderOptions"
      [multiple]="false"
      [activeValue]="editForm?.value.parentFolderId"
      (activeValueChange)="updateValue('parentFolderId', $event)"
      label="Parent"
      i18n-label="ParentFolderLabel"
    ></app-datalist-select>
  </div>
  <div class="form-group form-floating mb-3">
    <div class="form-group form-floating h-100 pb-3 d-grid">
      <button type="submit" class="btn btn-primary shadow-sm" i18n="@@save">
        {{ "save" | transloco }}
      </button>
    </div>
  </div>
</form>
